import React, { useCallback } from 'react';

import { useField } from 'formik';

import { IRadioSelectProps } from 'components/Controls/RadioSelect';
import { appReactMemo } from 'hocs';

import RadioSelect from '../../Controls/RadioSelect';

const FormikRadioSelect = ({ name, onChange, ...rest }: IRadioSelectProps) => {
  const [field, , helpers] = useField(name || '');

  const onValueChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, value: unknown) => {
      helpers.setValue(value, false);
      onChange?.(e, value);
    },
    [onChange, helpers],
  );

  return (
    <RadioSelect
      {...rest}
      name={name}
      onChange={onValueChange}
      value={field.value?.toString()}
    />
  );
};

export default appReactMemo(FormikRadioSelect);
